import PropTypes from 'prop-types';
import React from 'react';
import Dimensions from 'react-dimensions';

// wrapped components
import container from '../../containers/gameVenueControls';
import GameVenueControls from './controls.jsx';
import LocationSatelliteView from '../../../common/components/locationMapSatelliteEmbed.jsx';
import GameVenueStatus from './status.jsx';
import * as sharedStyles from '../../../common/libs/sharedStyles';

const styles = {
	controls : {
		display : 'flex',
	},
	left : {
		paddingRight : 5
	},
	right : {
		marginLeft : 'auto',
		fontWeight : 100,
		minWidth : 160,
		color : sharedStyles.vars.colors.ssGray
	},
	venueName : {
		fontSize : 16,
		color : sharedStyles.vars.colors.ssDarkGray
	},
	venueOfficialName : {
		fontSize : 13,
		color : sharedStyles.vars.colors.ssGray
	},
	status : {
		marginTop : 10,
	},
	mapWrapper : {
		marginBottom : 10
	}
};

class GameVenueMain extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			showMap: false
		};
	}

	_dataCheck(props) {
		const {game, getGame, venue} = props;

		if (!game && getGame) {
			getGame();
		}

		if (!venue && props.getVenue && props.venueId) {
			props.getVenue(props.venueId);
		}

		// figure out what the currently logged in user's assessment for this game/venue was
		if (props.authUser && !props.assessment && props.getAuthUserAssessment) {
			props.getAuthUserAssessment();
		}

		if (!props.gameVenueStatus && props.getGameVenueStatus) {
			props.getGameVenueStatus();
		}

		// TODO logic based on confirmation thing? authUser? etc...
		this.setState({
			showMap: !!venue,
		});
	}

	componentDidMount() {
		this._dataCheck(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this._dataCheck(nextProps);
	}

	renderLocation () {
		if (!this.state.showMap || !this.props.venue) { return; }

		const width = this.props.containerWidth;
		const height = Math.floor(width * 9 / 16);

		return (
			<div style={styles.mapWrapper}>
				<LocationSatelliteView
					locationId={this.props.venue.locationId}
					width={width}
					height={height}
				/>
			</div>
		);
	}

	render () {
		const {venue, authUser, gameVenueStatus} = this.props;


		const showOfficial = (venue && venue.officialName && venue.officialName !== venue.name && venue.officialName.indexOf(venue.name) === -1);

		return (
			<div>
				{this.renderLocation()}
				<div style={styles.controls}>
					<div style={styles.left}>
						{venue && <div style={styles.venueName}>{venue.name}</div>}
						{showOfficial && <div style={styles.venueOfficialName}>{venue.officialName}</div>}
						{gameVenueStatus && <GameVenueStatus style={styles.status} gameVenueStatus={gameVenueStatus} />}
					</div>
					<div style={styles.right}>
						{authUser && <GameVenueControls {...this.props}/>}
					</div>
				</div>
			</div>
		);
	}
}

GameVenueMain.propTypes = {
	authUser: PropTypes.object,
	containerWidth: PropTypes.number,
	gameId : PropTypes.number.isRequired,
	gameVenueStatus: PropTypes.object,
	venueId : PropTypes.number.isRequired,
	sportId : PropTypes.number.isRequired,
	venue : PropTypes.object,
};

/*
	I need to know gameId,
	I need to know sportId (icon)
	I need to know venueId for just about everything else

	Probably makes more sense for the widget to start with the gameId and not the venueId???

	I need to know the authUser to see if they can "updateGame"
	I need to know the authUserId to see if they are the GM of any teams
		... maybe the authUser object should be modified to include this?
*/
const Measured = Dimensions()(GameVenueMain);
export default container(Measured);
